import { useState, useRef, useEffect } from "react"
import styled from "styled-components"

//Import UI components to be used
import { Form } from '../form/FormComponents'
import SelectModal from "./SelectModal"
import ConnectInput from "./ConnectInput"

//setup for language State
import useTranslation from "../../hooks/useTranslation";
import RadioModal from "./RadioModal"

import { useModalStack } from "../../context/modalStackContext"
import useScreenSize from "../../hooks/useScreenSize"


const CompactText = styled.button`
    appearance: none;
    border: none;
    background: transparent;
    padding: 0;
    cursor: pointer;
    font-size: inherit;
    color: ${({ theme }) => theme.font.color};
    text-decoration: underline;
    text-underline-offset: 0.2em;
    text-align: left;

    &:hover {
        color: ${({ theme }) => theme.primary?.active || theme.font.active};
    }
`

const SearchContainer = styled.div`
    width: ${({ $width }) => $width || 'auto'};
    height: ${({ $height }) => $height || 'auto'};

    @media (min-width: ${({ theme }) => theme.breakpoint.xs}) {
        display: ${(props) => props.$alwaysOn ? 'block' : 'none'};
    }
`

const ConnectControl = ({
    data,
    onSelect,
    placeholder,
    valueName,
    entity,
    modalTitle,
    modalOpacity = 0.5,
    isRed,
    $alwaysOn,
    menuItemField,
    listDisplay,
    modalType = 'searchList',
    radioGroups,
    defaultSelection,
    options,
    persistValue,
    testId,
    origin = false,
    id,
    name,
    subObject,
    onClear,
    $marginBottom,
    $width,
    $height,
    compactOnMobile,
    manualEntry,
    onManualEntry,
    autoOpen,
    labelId,
    inputId,
    selectButtonKey,
    onSearch,
    emptyAdornment,
}) => {
    const [isVisible, setIsVisible] = useState(false);
    const { isMobile } = useScreenSize();
    const [sync, setSync] = useState(false);
    const searchContainer = useRef(null);
    const { t } = useTranslation()
    const inputRef = useRef(null);
    const modalIdRef = useRef(null);

    const { pushModal, updateModal } = useModalStack();

    //console.log('<ConnectControl> id: ', id) 

    //Hide & Show the Menu
    const showModal = () => {
        const sharedProps = {
            isVisible: true,
            setIsVisible,
            data,
            valueName,
            onSelect,
            entity,
            menuItemField,
            listDisplay,
            modalTitle,
            modalOpacity,
            options,
            persistValue,
            testId,
            onSearch,
        };

        if (modalType === 'searchList') {
            modalIdRef.current = pushModal(SelectModal, () => ({
                ...sharedProps,
                origin,
            }));
        } else if (modalType === 'radioGroup') {
            modalIdRef.current = pushModal(RadioModal, {
                ...sharedProps,
                radioGroups,
                defaultSelection,
                selectButtonKey,
            });
        }

        if (inputRef.current) {
            inputRef.current.blur(); // Blurs input to prevent keyboard pop-up
        }
        setIsVisible(true);
    }


    // Clear the stored modal id when the modal closes so stale ids are never used
    useEffect(() => {
        if (!isVisible) modalIdRef.current = null;
    }, [isVisible]);

    useEffect(() => {
        if (autoOpen) showModal()
    }, []);

    useEffect(() => {
        if (modalIdRef.current) {
            updateModal(modalIdRef.current, () => ({
                data,
            }))
        };
    }, [data])

    if (compactOnMobile && isMobile) {
        return (
            <CompactText onClick={showModal} data-testid={testId}>
                {valueName || t(placeholder)}
            </CompactText>
        )
    }

    return (
        <SearchContainer ref={searchContainer} $alwaysOn={$alwaysOn} $width={$width} $height={$height}>
            <Form.Group $marginBottom={$marginBottom} style={$height ? { height: '100%' } : undefined}>
                <ConnectInput
                    type="text"
                    valueName={valueName || ''}
                    name={name || entity}
                    showModal={showModal}
                    placeholder={t(placeholder)}
                    isRed={isRed}
                    autoComplete="off"
                    ref={inputRef}
                    readonly
                    pointerEvents="none"
                    testId={testId}
                    origin={origin}
                    entity={entity}
                    id={id}
                    onSelect={onSelect}
                    onClear={onClear}
                    sync={sync}
                    setSync={setSync}
                    manualEntry={manualEntry}
                    onManualEntry={onManualEntry}
                    labelId={labelId}
                    inputId={inputId}
                    emptyAdornment={emptyAdornment}
                />
            </Form.Group>
            {/* Modals are now managed by the modal stack context */}
        </SearchContainer>
    );
};

export default ConnectControl;
